import React from "react";
import { CircleAlert } from "lucide-react";

/**
 * DS Alert — 문구형 알림 배너.
 *   red    figma Alert_large 4449:63153 — Red/5 bg, px40 py12, column gap 8
 *          head: 아이콘 16 System/Error + 제목 Regular 14/22 System/Error / 설명 Regular 14/22 Text/Primary
 *   yellow figma Alert_medium 4659:121740 — Yellow/10 bg, px16 py12, row gap 8
 *          아이콘 16 Orange/50 + 문구 Regular 14/22 Text/Primary
 * DSErrorBanner(필수항목 리스트)·DSInfoBanner(readonly 안내) 와는 별개.
 *
 * title 이 없으면 아이콘 옆에 description 을 한 줄로 둔다(Alert_medium 형태).
 *
 * @param {object} props
 * @param {"red"|"yellow"} [props.tone="red"]
 * @param {React.ReactNode} [props.title]
 * @param {React.ReactNode} [props.description]
 * @param {string} [props.className]
 */
const DSAlert = ({ tone = "red", title, description, className = "" }) => (
  <div className={`ds-alert ds-alert--${tone} ${className}`} role={tone === "red" ? "alert" : "status"}>
    <div className="ds-alert__head">
      <CircleAlert className="ds-alert__icon" size={16} />
      {title ? (
        <span className="ds-alert__title">{title}</span>
      ) : (
        <span className="ds-alert__text">{description}</span>
      )}
    </div>
    {title && description ? <div className="ds-alert__desc">{description}</div> : null}
  </div>
);

export default React.memo(DSAlert);
